import SvgIcon from '@/pages/home/components/SvgIcon';
import React from 'react';
import { Select, SelectMultiple } from 'tea-component';
import { useIntl } from 'umi';
import './index.scss';

const TranslateSelect = ({
  isSingle = false,
  langOptions,
  lang,
  getChange,
  hideIcon = false,
  hideIconCommon = false,
  borderNone = false,
  isMatchButtonWidth = true,
  originalText = 'Original',
}: any) => {
  const { formatMessage } = useIntl();
  return isSingle ? (
    <Select
    className={`select-item dbo-translate-select ${borderNone ? 'dbo-translate-select--borderNone' : '' } ${hideIcon ? 'dbo-translate-select-link' : '' } ${hideIconCommon ? 'dbo-translate-select-common' : ''}`}
      boxClassName="select-translate-box-wrapper"
      appearance={ hideIcon||hideIconCommon ? "default" : "button"}
      matchButtonWidth={isMatchButtonWidth}
      options={langOptions}
      value={lang}
      onChange={(value, { event }) => {
        event.stopPropagation();
        getChange(value);
      }}
      button={(option) => (
        <div className="dbo-select-button">
          {!hideIcon && !hideIconCommon && (
            <SvgIcon type="translate" className="dbo-select-button-icon" />
          )}
          <div className="tea-text-overflow">
            {option?.text === 'Original Language' ? originalText : option?.text}
          </div>
        </div>
      )}
      footer={
        <div style={{ textAlign: 'left', maxWidth: 204 }}>
          {formatMessage({
            id: 'From GPT-Translator. Powered by DataBrain NLP Team',
          })}
        </div>
      }
    />
  ) : (
    <SelectMultiple
      className="select-item dbo-translate-select"
      boxClassName="select-translate-box-wrapper"
      staging={false}
      size="m"
      matchButtonWidth
      appearance="button"
      value={lang}
      onChange={(value, { event }) => {
        event.stopPropagation();
        getChange(value);
      }}
      options={langOptions}
      button={(option) => (
        <div className="dbo-select-button">
          <SvgIcon type="translate" className="dbo-select-button-icon" />
          <div className="tea-text-overflow">
            {option?.map((o, i) => (
              <span key={i}>
                {o.value ? (i > 0 ? `,  ${o.value}` : `${o.value}`) : ''}
              </span>
            ))}
          </div>
        </div>
      )}
      footer={
        <div style={{ textAlign: 'left', maxWidth: 204 }}>
          {formatMessage({
            id: 'From GPT-Translator. Powered by DataBrain NLP Team',
          })}
        </div>
      }
    />
  );
};

export default TranslateSelect;
